( (window, document) => {
  "use strict";
  const $ = window.jQuery;
  let newsticker = $( '.vodl-newsticker.pre-init' );

  const init_newsticker = () => {

    newsticker = $( '.vodl-newsticker.pre-init' );

    newsticker.each(function(){
      let postWrapper = $(this).find('.vodl-newsticker__post-wrapper');
      $(this).removeClass('pre-init');
      postWrapper.each(function () {
        $(this).mouseenter(function () {
          //close current opened post_wrapper by removing the class --open
          if ($(this).not('.vodl-newsticker__post-wrapper--open')) {
            $(this).parent().find('.vodl-newsticker__post-wrapper--open').toggleClass('vodl-newsticker__post-wrapper--open');
            $(this).addClass('vodl-newsticker__post-wrapper--open');
          }
        });
      });
    });

  };

  $(document).ready( () => {

    // Check how to initialize - directly or handled by event listener.
    if ( newsticker.length > 0 ) {
      init_newsticker();
    }

    // Initialize event listener for lazy newsticker.
    window.addEventListener('newPage', init_newsticker, false);

  });
})(window, document);
